import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { IUser } from '../../../../types/user'
import { updateUser, fetchUsers } from '../../../../store/users/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { Edit } from './Edit'
import { IEditDispatchProps } from './types'
import { IStateProps } from '../types'
import { IState } from '../../../../store/types'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    users: state.users,
    installations: state.installations
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IEditDispatchProps => {
  return {
    fetchUsers: () => {
      return dispatch(fetchUsers())
    },
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },
    updateUser: (user: IUser) => {
      return dispatch(updateUser(user))
    }
  }
}

const EditContainer = connect(mapStateToProps, mapDispatchToProps)(Edit)

export {
  EditContainer
}
